import { showToast } from "@/providers";

type AppErrorOptions = Readonly<{
  handleUnknownError?: boolean;
  unknownErrorTitle?: string;
}>;

export function handleAppError(
  error: unknown,
  {
    handleUnknownError = false,
    unknownErrorTitle = "Erro inesperado. Tente novamente mais tarde.",
  }: AppErrorOptions = {},
): void {
  if (error instanceof AppError || error instanceof APIError || error instanceof FormError) {
    showToast({
      type: "error",
      title: error.message,
    });
  } else if (handleUnknownError) {
    showToast({
      type: "error",
      title: unknownErrorTitle,
    });
  } else {
    throw error;
  }
}

export function isNextRedirectException(error: any): boolean {
  return error?.message === "NEXT_REDIRECT";
}

/**
 * Erro que pode ser lançado para interromper o fluxo de execução e exibir um toast de erro ao usuário.
 *
 * @class
 * @extends Error
 */
export class AppError extends Error {
  constructor(
    message: string,
    public readonly info?: any,
  ) {
    super(message);
  }
}

export class APIError extends Error {
  constructor(
    public response: { message: string; validationErrors?: ValidationError[] },
    public statusCode: number,
  ) {
    super(response.message);
  }
}

export interface ValidationError {
  property: string;
  constraints: Record<string, string>;
}

export class FormError extends Error {
  constructor(
    message: string,
    public properties: PropertyError[],
  ) {
    super(message);
  }
}

interface PropertyError {
  property: string;
  errorMessages: string[];
}
